import React from 'react';
import './styling.css';

function HeaderComponent({ question }) {
  return (
    <div className="shared-padding header-component">
      <h2 className="header-title">{question.Text}</h2>
      {question['Sub Text/Selection '] && (
        <div className="header-subtext">{question['Sub Text/Selection ']}</div>
      )}
    </div>
  );
}

export default HeaderComponent;
